import { Component, computed } from '@angular/core';
import { TelephoneLinkComponent } from '../../../../shared/components/telephone-link/telephone-link.component';
import { MmrService } from '../../services/mmr.service';
import { capitaliseText } from '../../../../shared/utils/formatting';
import { ClaimDetailsPanelDirectReferral } from '../../types/mmr-claims.type';

@Component({
  selector: 'app-direct-referral',
  imports: [TelephoneLinkComponent],
  templateUrl: './direct-referral.component.html',
  styleUrl: './direct-referral.component.scss',
  host: {
    class: 'p-24 md-p-16',
  },
})
export class DirectReferralComponent {
  protected viewModel = computed(() => {
    const planDetails = this.mmrService.planClaimsDetails.plan;
    const claimsDetails = this.mmrService.planClaimsDetails.claims;

    const details = claimsDetails.value()['repair'] as ClaimDetailsPanelDirectReferral;

    return {
      repairer: capitaliseText(planDetails.value()?.manufacturer),
      phoneNumber: details?.contactPhone,
      postCode: claimsDetails.value()?.addressInformation?.postalCode,
      website: details?.contactWebsite,
      email: details?.contactEmail,
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}
}
